// extracted by mini-css-extract-plugin
module.exports = {"writingArea":"AddPostForm_writingArea__1e7fc","textarea":"AddPostForm_textarea__1xP5a","button":"AddPostForm_button__hHTze","buttonWrapper":"AddPostForm_buttonWrapper__2FUb1"};